const getPrices = (orderLineItem)=>{
    var ref, ref1;
    var ref2;
    const lineItemOriginalPrice = (ref2 = (ref = orderLineItem.price) === null || ref === void 0 ? void 0 : ref.productPrice) !== null && ref2 !== void 0 ? ref2 : 0;
    var ref3;
    const totalPaid = (ref3 = (ref1 = orderLineItem.price) === null || ref1 === void 0 ? void 0 : ref1.totalPaid) !== null && ref3 !== void 0 ? ref3 : undefined;
    const lineItemDiscountedPrice = totalPaid === lineItemOriginalPrice ? undefined : totalPaid;
    return {
        lineItemOriginalPrice,
        lineItemDiscountedPrice
    };
};

export { getPrices };
//# sourceMappingURL=get-prices.js.map
